<script lang="ts" module>
	export interface NavLinkProps {
		label: string | undefined;
		href: string | undefined;
		dataCy: string;
		onclick?: () => void;
		items?: GlobalNavLinkItem[];
		isLive?: boolean;
		pathname?: string;
	}
</script>

<script lang="ts">
	import classNames from 'classnames';
	import { Link } from '../../../../components/Link';
	import { Txt } from '../../../../components/Txt';
	import type { GlobalNavLinkItem } from '../../types';
	import { NavDropdown } from './NavDropdown';

	let {
		label,
		items,
		href,
		dataCy,
		onclick,
		isLive = false,
		pathname = ''
	}: NavLinkProps = $props();

	const isPathActive = (candidate?: string) =>
		!!candidate?.startsWith('/') &&
		(pathname === candidate || pathname.startsWith(`${candidate}/`));

	let active = $derived(isPathActive(href) || !!items?.some((item) => isPathActive(item.href)));
</script>

{#if items?.length}
	<NavDropdown {items} {label} {dataCy} {pathname} {active} />
{:else}
	<Link
		{dataCy}
		{href}
		{onclick}
		class={classNames(
			'flex h-full items-center gap-2 border-b-2 border-transparent py-1 hover:border-b-gray-0',
			active && 'border-b-gray-0'
		)}
		aria-current={active ? 'page' : undefined}
	>
		{#if isLive}
			<div class="h-[8px] w-[8px] rounded-full bg-green-300" data-cy={`${dataCy}-live-dot`}></div>
		{/if}
		<Txt class="text-gray-0 tracking-[.14em] uppercase" variant="body2">{label}</Txt>
	</Link>
{/if}
